export type DurationBillingItem = {
  durationBillingId?: string;
  duration?: number | null;
  billingFrequency:
    | 'ONE_TIME'
    | 'MONTHLY'
    | 'EVERY_OTHER_MONTH'
    | 'QUARTERLY'
    | 'BI_ANNUAL'
    | 'ANNUAL';
  salePrice: number;
  active?: boolean;
  useMembershipPricingTable?: boolean;
};

type MembershipTypeWithBilling = {
  membershipTypeId: string;
  billingTemplateId?: string | null;
  useMembershipPricingTable?: boolean;
  durationBilling: DurationBillingItem[];
};

type InvoiceTemplate = {
  invoiceTemplateId: string;
  items: { invoiceTemplateSkuId: string }[];
};

export type DurationBillingIndex = {
  skuToTemplateId: Map<string, string>;
  templateIdToMembershipTypes: Map<string, MembershipTypeWithBilling[]>;
};

export function buildDurationBillingIndex(
  membershipTypes: MembershipTypeWithBilling[],
  invoiceTemplates: InvoiceTemplate[]
): DurationBillingIndex {
  const skuToTemplateId = new Map<string, string>();
  for (const template of invoiceTemplates) {
    for (const item of template.items) {
      skuToTemplateId.set(
        item.invoiceTemplateSkuId,
        template.invoiceTemplateId
      );
    }
  }

  const templateIdToMembershipTypes = new Map<
    string,
    MembershipTypeWithBilling[]
  >();
  for (const mt of membershipTypes) {
    if (mt.billingTemplateId) {
      const existing =
        templateIdToMembershipTypes.get(mt.billingTemplateId) || [];
      templateIdToMembershipTypes.set(mt.billingTemplateId, [...existing, mt]);
    }
  }

  return { skuToTemplateId, templateIdToMembershipTypes };
}

export function lookupDurationBilling(
  index: DurationBillingIndex,
  pricebookId: string
): DurationBillingItem[] {
  const templateId = index.skuToTemplateId.get(pricebookId);

  return templateId
    ? (index.templateIdToMembershipTypes.get(templateId) ?? []).flatMap(
        (mt) =>
          mt.durationBilling.map((db) => ({
            ...db,
            useMembershipPricingTable: mt.useMembershipPricingTable,
          }))
      )
    : [];
}
